module.exports = __webpack_public_path__ + "img/map_marker.1e132c82.svg";